/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StudyCycleEnum,
    StudyCycleEnumFromJSON,
    StudyCycleEnumFromJSONTyped,
    StudyCycleEnumToJSON,
} from './StudyCycleEnum';

/**
 * 
 * @export
 * @interface DuplicateStudyPlansRequest
 */
export interface DuplicateStudyPlansRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DuplicateStudyPlansRequest
     */
    facultyIds?: Array<string> | null;
    /**
     * 
     * @type {StudyCycleEnum}
     * @memberof DuplicateStudyPlansRequest
     */
    studyCycle?: StudyCycleEnum;
    /**
     * 
     * @type {number}
     * @memberof DuplicateStudyPlansRequest
     */
    newPlanYear?: number;
}

export function DuplicateStudyPlansRequestFromJSON(json: any): DuplicateStudyPlansRequest {
    return DuplicateStudyPlansRequestFromJSONTyped(json, false);
}

export function DuplicateStudyPlansRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateStudyPlansRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facultyIds': !exists(json, 'facultyIds') ? undefined : json['facultyIds'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : StudyCycleEnumFromJSON(json['studyCycle']),
        'newPlanYear': !exists(json, 'newPlanYear') ? undefined : json['newPlanYear'],
    };
}

export function DuplicateStudyPlansRequestToJSON(value?: DuplicateStudyPlansRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facultyIds': value.facultyIds,
        'studyCycle': StudyCycleEnumToJSON(value.studyCycle),
        'newPlanYear': value.newPlanYear,
    };
}

